import React, {useEffect, useCallback} from 'react'
import {Overlay, Panel} from './drawer.styles'

export default function Drawer({
  isOpen = false,
  onClose,
  direction = 'left',
  size = '320px',
  closeOnOverlay = true,
  closeOnEscape = true,
  children,
  className = '',
}) {
  const handleClose = useCallback(() => {
    onClose?.()
  }, [onClose])

  useEffect(() => {
    if (!closeOnEscape) return
    const handler = e => {
      if (e.key === 'Escape' && isOpen) handleClose()
    }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [isOpen, closeOnEscape, handleClose])

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  return (
    <>
      <Overlay
        aria-hidden="true"
        isOpen={isOpen}
        onClick={closeOnOverlay ? handleClose : undefined}
      />
      <Panel
        role="dialog"
        aria-modal="true"
        aria-hidden={!isOpen}
        isOpen={isOpen}
        direction={direction}
        style={{'--drawer-size': size}}
        className={className}
      >
        {children}
      </Panel>
    </>
  )
}
